import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import GuideDetailForm from '../Forms/GuideDetailForm';
import ResidueCollectedForm from '../../Forms/ResidueCollectedForm';

const AddEditResidueBeachCleaningModal = ({
	isOpen,
	isEdit,
	handleToggleModal,
	handleResidueCollectedSelectList,
	idsSelectedItem,
	handleIdsSelectedItem
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Residuos De Limpieza
			</ModalHeader>
			<ResidueCollectedForm
				isOpen={isOpen}
				handleToggleModal={handleToggleModal}
				handleResidueCollectedSelectList={handleResidueCollectedSelectList}
				idsSelectedItem={idsSelectedItem}
				handleIdsSelectedItem={handleIdsSelectedItem}
			/>
		</Modal>
	);
};

export default AddEditResidueBeachCleaningModal;